import { HttpInterceptorFn } from '@angular/common/http';
import { LoaderService } from '@shared/services/loader.service';
import { finalize } from 'rxjs';
import { inject } from '@angular/core';
import { environment } from '@env/environment';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoaderService);

  loadingService.show();
  if (req.params.get('loader') === 'false') {
    loadingService.hide(); // Ocultar el indicador de carga
  }
  return next(req).pipe(
    finalize(() => {
      if (!environment.production) {
        console.log('loaderInterceptor', req.url);
      }
      if (req.params.get('loader') !== 'false') {
        loadingService.hide(); // Ocultar el indicador de carga
      }
    }),
  );
};
